import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { CDN_LINK } from "@globalConfig";
import { api__getRecentlyViewedPostsData } from "@/apis/recentlyViewed/api__getRecentlyViewedPostsData";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import { api__getRecentViewCarsIds } from "@/apis/recentlyViewed/api__getRecentViewCarsIds";
import { api__bulkAddRecentViewCars } from "@/apis/recentlyViewed/api__bulkAddRecentViewCars";
import { api__getRecentViewCarsPosts } from "@/apis/recentlyViewed/api__getRecentViewCarsPosts";
import useKeyPressAndTapSwitch from "@hooks/useKeyPressSwitch";
import Loader from "@componentsShared/Loader/Loader";
import useLocalStorage from "@hooks/useLocalStorage";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
import Container from "@/components/sharedComponents/container/Container";
var LOCAL_STORAGE_KEY = "recently_viewed_data";
var LOCAL_STORAGE_SNAPSHOT_KEY = "recently_viewed_snapshot"; // New snapshot storage

var RecentlyViewedContext = /*#__PURE__*/createContext(undefined);
var RecentlyViewedProvider = function RecentlyViewedProvider(_ref) {
  var children = _ref.children;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var isMobile = useIsMobile();
  var _useState = useState(true),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState({
      carsIds: [],
      maxCars: 20,
      referral_location: "",
      carsData: []
    }),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(false),
    showOldCard = _useState3[0],
    setShowOldCard = _useState3[1];
  var _useLocalStorage = useLocalStorage(),
    getLocalStorage = _useLocalStorage.getLocalStorage,
    setLocalStorage = _useLocalStorage.setLocalStorage;
  var handleKeyPressSwitch = function handleKeyPressSwitch() {
    setShowOldCard(!showOldCard);
  };
  useKeyPressAndTapSwitch(handleKeyPressSwitch);
  useEffect(function () {
    var storedData = getLocalStorage(LOCAL_STORAGE_KEY);
    if (storedData) {
      try {
        var parsedData = JSON.parse(storedData);
        setData(parsedData);
      } catch (error) {
        console.error("Failed to parse localStorage data", error);
      }
    }
  }, []);
  useEffect(function () {
    setLocalStorage(LOCAL_STORAGE_KEY, JSON.stringify(data));
  }, [data]);
  useEffect(function () {
    loading && !isLoggedIn && setLoading(false);
  }, [isLoggedIn]);
  var handleLoginUpdated = function handleLoginUpdated() {
    var _localStorage, _data$carsIds, _data$carsIds2, _data$carsIds3, _data$carsIds5, _data$carsData;
    var CB = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (!isLoggedIn) return;
    var storedSnapshot = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(LOCAL_STORAGE_SNAPSHOT_KEY);
    var lastSavedCarsIds = storedSnapshot && storedSnapshot != "undefined" ? JSON === null || JSON === void 0 ? void 0 : JSON.parse(storedSnapshot) : [];

    // If no change in carsIds, don't hit the API
    if ((data === null || data === void 0 ? void 0 : (_data$carsIds = data.carsIds) === null || _data$carsIds === void 0 ? void 0 : _data$carsIds.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$carsIds2 = data.carsIds) === null || _data$carsIds2 === void 0 ? void 0 : _data$carsIds2.length) === (lastSavedCarsIds === null || lastSavedCarsIds === void 0 ? void 0 : lastSavedCarsIds.length) && data !== null && data !== void 0 && data.carsIds.every(function (car, index) {
      var _lastSavedCarsIds$ind;
      return car.post_id === ((_lastSavedCarsIds$ind = lastSavedCarsIds[index]) === null || _lastSavedCarsIds$ind === void 0 ? void 0 : _lastSavedCarsIds$ind.post_id);
    })) {
      setLoading(false);
      return;
    }
    if ((data === null || data === void 0 ? void 0 : (_data$carsIds3 = data.carsIds) === null || _data$carsIds3 === void 0 ? void 0 : _data$carsIds3.length) > 0) {
      api__bulkAddRecentViewCars(data.carsIds).then(function (res) {
        var _res$data, _data$carsIds4, _res$data2;
        if (!Array.isArray(res === null || res === void 0 ? void 0 : res.data)) return;
        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.length) !== (data === null || data === void 0 ? void 0 : (_data$carsIds4 = data.carsIds) === null || _data$carsIds4 === void 0 ? void 0 : _data$carsIds4.length) || !(res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.every(function (car, index) {
          var _data$carsIds$index;
          return car.post_id === ((_data$carsIds$index = data.carsIds[index]) === null || _data$carsIds$index === void 0 ? void 0 : _data$carsIds$index.post_id);
        }))) {
          updateData("carsIds", res === null || res === void 0 ? void 0 : res.data);

          // Update snapshot in localStorage after API call
          setLocalStorage(LOCAL_STORAGE_SNAPSHOT_KEY, JSON.stringify(res === null || res === void 0 ? void 0 : res.data));
        }
        CB ? CB() : undefined;
      })["catch"](function (error) {
        return console.error("Error updating recent view cars:", error);
      });
    } else if ((data === null || data === void 0 ? void 0 : (_data$carsIds5 = data.carsIds) === null || _data$carsIds5 === void 0 ? void 0 : _data$carsIds5.length) === 0) {
      api__getRecentViewCarsIds().then(function (res) {
        var _res$data3, _data$carsIds6;
        if (!Array.isArray(res === null || res === void 0 ? void 0 : res.data)) return;
        if ((res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.length) !== (data === null || data === void 0 ? void 0 : (_data$carsIds6 = data.carsIds) === null || _data$carsIds6 === void 0 ? void 0 : _data$carsIds6.length) || !(res !== null && res !== void 0 && res.data.every(function (car, index) {
          var _data$carsIds$index2;
          return car.post_id === ((_data$carsIds$index2 = data.carsIds[index]) === null || _data$carsIds$index2 === void 0 ? void 0 : _data$carsIds$index2.post_id);
        }))) {
          updateData("carsIds", res === null || res === void 0 ? void 0 : res.data);
          // Update snapshot in localStorage after API call
          setLocalStorage(LOCAL_STORAGE_SNAPSHOT_KEY, JSON.stringify(res === null || res === void 0 ? void 0 : res.data));
        } else {
          setLoading(false);
        }
      })["catch"](function (error) {
        return console.error("Error fetching recent view cars:", error);
      });
    } else if (loading && (data === null || data === void 0 ? void 0 : (_data$carsData = data.carsData) === null || _data$carsData === void 0 ? void 0 : _data$carsData.length) === 0) {
      setLoading(false);
    }
  };
  var updateData = function updateData(path, value) {
    setData(function (prev) {
      var keys = path.split(".");
      var current = prev;
      keys.slice(0, -1).forEach(function (key) {
        if (!current[key]) {
          current[key] = {};
        }
        current = current[key];
      });
      current[keys[(keys === null || keys === void 0 ? void 0 : keys.length) - 1]] = value;
      return _objectSpread({}, prev);
    });
  };
  var addCarIDtoViewedList = function addCarIDtoViewedList(postId) {
    if (!postId) {
      console.error("Invalid postId:", postId);
      return;
    }
    var formattedDate = "" + Math.floor(Date.now() / 1000);

    // Safely handle undefined or non-array Data.carsIds
    var updatedCars = _toConsumableArray(Array.isArray(data === null || data === void 0 ? void 0 : data.carsIds) ? data.carsIds : []);

    // Check if the post_id already exists in the list
    var existingIndex = updatedCars.findIndex(function (item) {
      return item.post_id === postId;
    });
    if (existingIndex !== -1) {
      // If it exists, remove it from the current position
      updatedCars.splice(existingIndex, 1);
    }

    // Add the new post_id with the current timestamp to the beginning of the list
    updatedCars.unshift({
      post_id: postId,
      view_date: formattedDate
    });

    // Remove the oldest item if the list exceeds the maximum allowed number of cars
    if ((updatedCars === null || updatedCars === void 0 ? void 0 : updatedCars.length) > data.maxCars) {
      updatedCars.pop();
    }

    // Safely update the data
    if (typeof updateData === "function") {
      updateData("carsIds", updatedCars);
    } else {
      console.error("updateData function is not defined.");
    }
  };
  var renderRecentlyViewedCars = function renderRecentlyViewedCars() {
    var _data$carsIds7, _data$carsIds8, _data$carsData2, _data$carsData3, _data$carsData4;
    var customClassName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    handleLoginUpdated();
    ((_data$carsIds7 = data.carsIds) === null || _data$carsIds7 === void 0 ? void 0 : _data$carsIds7.length) > 0 && api__getRecentlyViewedPostsData(data.carsIds, data.maxCars).then(function (res) {
      if (JSON.stringify(res === null || res === void 0 ? void 0 : res.data) !== JSON.stringify(data === null || data === void 0 ? void 0 : data.carsData)) {
        updateData("carsData", res === null || res === void 0 ? void 0 : res.data);
      }
    });
    if ((data === null || data === void 0 ? void 0 : (_data$carsIds8 = data.carsIds) === null || _data$carsIds8 === void 0 ? void 0 : _data$carsIds8.length) === 0 || !(data !== null && data !== void 0 && data.carsIds)) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "lg:!py-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: ["bg-[#F1F6FC] mt-[32px] pt-8 pb-[40px] lg:mt-0", customClassName !== null && customClassName !== void 0 ? customClassName : undefined].join(" ")
    }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("h2", {
      className: "big !px-[20px]"
    }, t("recently_viewed_cars", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("div", {
      className: "overflow-x-auto md:overflow-x-visible"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex gap-5 flex-nowrap overflow-auto px-5 snap-x snap-mandatory mt-8 lg:grid lg:grid-cols-[repeat(auto-fill,minmax(273px,1fr))] lg:gap-5 list-none lg:pb-0 lg:mt-0 lg:px-0"
    }, data === null || data === void 0 ? void 0 : (_data$carsData2 = data.carsData) === null || _data$carsData2 === void 0 ? void 0 : _data$carsData2.map(function (car, idx) {
      return idx < 4 ? /*#__PURE__*/React.createElement("div", {
        className: "lg:w-full min-h-full w-[300px] flex-shrink-0",
        key: car === null || car === void 0 ? void 0 : car.id
      }, /*#__PURE__*/React.createElement(ModernCard, {
        post: car,
        isEager: true,
        metaData: {},
        page: 1,
        rank: idx + 1,
        sectionType: "recently viewed",
        titleTag: "h3",
        isAnchor: true
      })) : null;
    }), isMobile && (data === null || data === void 0 ? void 0 : (_data$carsData3 = data.carsData) === null || _data$carsData3 === void 0 ? void 0 : _data$carsData3.length) > 4 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      className: "rounded bg-[#3C56D4] shadow-md min-w-[166px] min-h-full flex items-center justify-between px-6 text-white text-lg font-bold leading-6",
      href: createUrl("/site/recently-viewed")
    }, /*#__PURE__*/React.createElement("span", null, t("show_cars", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/moreLinkArrow.svg",
      alt: "icon",
      className: "en:rotate-180"
    })), /*#__PURE__*/React.createElement("div", {
      className: "min-w-[1px] h-[1px]"
    })))), !isMobile && (data === null || data === void 0 ? void 0 : (_data$carsData4 = data.carsData) === null || _data$carsData4 === void 0 ? void 0 : _data$carsData4.length) > 4 && /*#__PURE__*/React.createElement("a", {
      className: "redBtn h-[48px] w-[250px] rounded flex items-center justify-center font-bold leading-6 mx-auto p-[10px] px-[15px] text-[14px] text-center mt-[40px]",
      href: createUrl("/site/recently-viewed")
    }, t("continue_browsing", {
      ns: "web_common"
    })))));
  };
  var renderAllRecentlyViewed = function renderAllRecentlyViewed() {
    var _data$carsData5, _data$carsData6;
    loading && isLoggedIn && handleLoginUpdated(function () {
      api__getRecentViewCarsPosts(data.maxCars).then(function (res) {
        if (JSON.stringify(res === null || res === void 0 ? void 0 : res.data) !== JSON.stringify(data === null || data === void 0 ? void 0 : data.carsData)) {
          updateData("carsData", res === null || res === void 0 ? void 0 : res.data);
        }
      })["finally"](function () {
        setLoading(false);
      });
    });
    if (loading) return /*#__PURE__*/React.createElement(Loader, null);
    if ((data === null || data === void 0 ? void 0 : (_data$carsData5 = data.carsData) === null || _data$carsData5 === void 0 ? void 0 : _data$carsData5.length) === 0) return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center flex-col mt-20"
    }, !isMobile && /*#__PURE__*/React.createElement("h2", {
      className: "big"
    }, t("recently_viewed_cars", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center flex-col md:after:content-[''] md:after:bg-[#F4F7FB;] md:after:fixed md:after:z-[-1] md:after:block md:after:w-full md:after:h-full md:after:top-0 md:after:left-0 md:min-w-[567px] md:h-[446px] md:rounded-[16px] md:bg-white "
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/History.svg",
      alt: "history"
    }), /*#__PURE__*/React.createElement("strong", {
      className: "text-[#154F9C] text-center text-2xl font-bold leading-[32px] mt-6"
    }, t("no_results_found", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[#154F9C] text-lg font-semibold leading-[28px] mt-6 text-center max-w-[90%] mx-auto"
    }, t("start_browsing_cars_see_results", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("a", {
      href: createUrl("/filters"),
      className: "flex items-center justify-center blueBtn w-[90%] md:w-[318px] h-[56px] rounded-[5px] mt-6"
    }, t("browse_cars_2", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("a", {
      href: createUrl("/"),
      className: "flex items-center justify-center whtBtn w-[90%] md:w-[318px] h-[56px] rounded-[5px] mt-3"
    }, t("go_homepage", {
      ns: "web_common"
    }))));
    return /*#__PURE__*/React.createElement(Container, {
      className: "!mt-[24px] md:!mt-[72px] pb-[40px]"
    }, !isMobile && /*#__PURE__*/React.createElement("h2", {
      className: "big"
    }, t("recently_viewed_cars", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("section", {
      className: "max-w-full px-4 mx-auto lg:max-w-[992px] xl:max-w-[1130px] 2xl:max-w-[1330px]"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-[repeat(auto-fill,minmax(273px,1fr))] gap-5 lg:mx-auto"
    }, data === null || data === void 0 ? void 0 : (_data$carsData6 = data.carsData) === null || _data$carsData6 === void 0 ? void 0 : _data$carsData6.map(function (car, idx) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        id: "recent-car-card",
        className: "w-full"
      }, /*#__PURE__*/React.createElement(ModernCard, {
        post: car,
        key: idx,
        rank: idx + 1,
        HasImageSlider: checkFeatureFlag("FF_ENABLE_MULTI_LIST_GALLERY"),
        sectionType: "recently viewed",
        isAnchor: true
      })));
    }))));
  };
  return /*#__PURE__*/React.createElement(RecentlyViewedContext.Provider, {
    value: {
      updateData: updateData,
      Data: data,
      addCarIDtoViewedList: addCarIDtoViewedList,
      renderRecentlyViewedCars: renderRecentlyViewedCars,
      renderAllRecentlyViewed: renderAllRecentlyViewed
    }
  }, children);
};
var useRecentlyViewedContext = function useRecentlyViewedContext() {
  var context = useContext(RecentlyViewedContext);
  if (!context) {
    throw new Error("useRecentlyViewedContext must be used within a RecentlyViewedProvider");
  }
  return context;
};
export { RecentlyViewedProvider, useRecentlyViewedContext };